import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!

  return (_openBlock(), _createBlock(_component_ButtonGroup, {
    "onUpdate:modelValue": _ctx.navigate,
    color: "secondary",
    "model-value": _ctx.selected,
    options: _ctx.options,
    object: true
  }, {
    default: _withCtx((slotProps) => [
      _createTextVNode(_toDisplayString((slotProps.option as any).title), 1)
    ]),
    _: 1
  }, 8, ["onUpdate:modelValue", "model-value", "options"]))
}